<template>
  <div class="accountManagement">
    <header>
      <el-button
        type="primary"
        style="margin-right: 30px;"
        @click="adddata"
      >新增</el-button>
      <el-input
        v-model="wechatAppletquery.name"
        style="max-width: 200px; margin-right: 18px"
        placeholder="小程序名称"
      />
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="wechatSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="wechatReset"
      >重置</el-button>
      <el-button
        type="primary"
        @click="$refs.inputFile.click()"
      >导入表格
        <input
          ref="inputFile"
          type="file"
          style="display: none;"
          @change="importReport"
        >
      </el-button>
    </header>
    <main>
      <el-table
        v-loading="loading"
        :data="selectData.list"
        border
        style="width: 100%"
      >
        <!-- <el-table-column prop="id" label="id" min-width="100" /> -->
        <el-table-column
          prop="name"
          label="名称"
          min-width="150"
        />
        <el-table-column
          prop="account"
          label="登录账号"
          min-width="180"
        />
        <el-table-column
          prop="notice_time"
          label="报警时间"
          min-width="150"
        />
        <el-table-column
          prop="handle_time"
          label="处理时间"
          min-width="150"
        />
        <!-- <el-table-column prop="platform_name" label="平台" min-width="150" />
        <el-table-column prop="novel_name" label="小说" min-width="150" />
        <el-table-column prop="lead" label="主角" min-width="100" /> -->

        <el-table-column
          prop="charge_person"
          label="负责人"
          min-width="150"
        />
        <el-table-column
          prop="telephone"
          label="联系电话"
          min-width="150"
        />
        <el-table-column
          prop="notice_info"
          label="警告信息"
          min-width="150"
        />
        <el-table-column
          prop="status"
          label="运行状态"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-show="scope.row.work_status === 1">{{ scope.row.work_status_str }}</el-tag>
            <el-tag
              v-show="scope.row.work_status === 2"
              type="info"
            >{{ scope.row.work_status_str }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="处理状态"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-show="scope.row.handle_status === 1">{{ scope.row.notice_status_str }}</el-tag>
            <el-tag
              v-show="scope.row.handle_status === 2"
              type="info"
            >{{ scope.row.notice_status_str }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="是否纳入监控"
          min-width="125"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.include_status"
              :active-value="1"
              :inactive-value="2"
              @change="changeradio(scope.row)"
            />
            <!-- <el-tag v-show="scope.row.handle_status === 1">{{ scope.row.notice_status_str }}</el-tag>
            <el-tag v-show="scope.row.handle_status === 2" type="info">{{ scope.row.notice_status_str }}</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="140"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="wechatedit(scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              @click="deleteone(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <pagination-right
      :total="selectData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <global-window
      title="授权"
      :visible.sync="dialogVisible"
      :show="true"
      width="1000px"
      @close="closeDialog"
      @confirm="closeDialog"
    >
      <iframe
        v-if="iframeURL === null ? false : true"
        width="960"
        height="600"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        scrolling="no"
        :src="iframeURL"
      />
    </global-window>
    <add-account-drawer ref="addAccountDrawer" />

    <el-dialog
      :width="'30%'"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="close"
    >
      <wechat-Form
        ref="wechatform"
        @updata="updata"
      />
      <!-- <el-form ref="downloadquery" label-width="180px" :model="downloadquery">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="downloadquery.start_date"
            :clearable="false"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="downloadquery.end_date"
            :clearable="false"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="颜色选择">
          <div class="block">
            <el-color-picker v-model="downloadquery.key_word_color" color-format="hex" />
          </div>
        </el-form-item>
        <div style="padding-left: 330px;">
          <el-button type="primary" @click="sumbitdown">确定</el-button>
        </div>

      </el-form> -->

    </el-dialog>
  </div>
</template>

<script>
import { getList, modify, getURL, getwechat, deletewechat, updatawechat, importReport } from '@/api/report/accountManagement'
import PaginationRight from '@/components/PaginationRight/index.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
import addAccountDrawer from '@/views/report/WeChatAccountFans/components/accountOfficialdrawer.vue'
import wechatForm from '@/views/wechatApplet/components/wechantform.vue'
export default {
  name: 'Applet',
  components: {
    PaginationRight,
    GlobalWindow,
    addAccountDrawer,
    wechatForm
  },
  data() {
    return {
      title: '',
      query: '', // 空是新增 有id是编辑
      tableData: {},
      flag: false,
      authorizeURL: null,
      wechatAccountsQuery: {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      },
      wechatAppletquery: {
        name: '',
        page: 1,
        page_size: 10
      },
      selectData: {}, // 列表数据，包括筛选条件数据
      loading: null, // 加载效果
      iframeURL: null,
      dialogFormVisible: false,
      dialogVisible: false
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (!newValue) {
        this.iframeURL = null
      }
    }
  },
  created() {
    // this.getListData()
    this.getweichatlist()
  },
  methods: {
    changeradio(val) {
      updatawechat(val.id, {
        name: val.name,
        account: val.account,
        pwd: val.pwd,
        charge_person: val.charge_person,
        telephone: val.telephone,
        handle_status: Number(val.handle_status),
        include_status: val.include_status
      }).then(response => {
        this.$message({
          message: this.$t('修改成功'),
          type: 'success'
        })
        this.getweichatlist()
      })
    },
    updata() {
      this.getweichatlist()
      this.dialogFormVisible = false
    },
    // 获取小程序列表
    getweichatlist() {
      this.loading = true
      getwechat(this.wechatAppletquery).then(res => {
        this.selectData = res.data
        this.loading = false
      })
    },
    // 搜索
    wechatSearch() {
      this.getweichatlist()
    },
    // 重置
    wechatReset() {
      this.wechatAppletquery = {
        name: '',
        page: 1,
        page_size: 10
      }
      this.getweichatlist()
    },
    // 关闭弹窗
    close() {
      setTimeout(() => {
        this.$refs.wechatform.qudiao()
      }, 0)
    },
    // 添加
    adddata() {
      this.title = '新增小程序'
      setTimeout(() => {
        this.$refs.wechatform.add()
      }, 0)
      this.dialogFormVisible = true
    },
    // 编辑
    wechatedit(id) {
      this.title = '编辑小程序'
      setTimeout(() => {
        this.$refs.wechatform.edittwi(id)
      }, 0)
      // if (this.$refs.wechatform) {
      //   this.$nextTick(() => {
      //     this.$refs.wechatform.edittwi(id)
      //   })
      // }
      this.dialogFormVisible = true
    },
    // 删除
    async deleteone(id) {
      await deletewechat(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      await this.getweichatlist()
    },
    // 获取列表数据，包括筛选条件列表
    getListData() {
      this.loading = true
      getList(this.wechatAccountsQuery).then(res => {
        this.selectData = res.data
        this.loading = false
      })
    },
    // 跳转到授权页面
    getURLData() {
      this.dialogVisible = true
      getURL().then(res => {
        this.iframeURL = res.data.wechat
        // window.open(res.data)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.iframeURL = null
    },
    // 搜索小说
    handleSearch() {
      this.wechatAccountsQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    handleReset() {
      this.wechatAccountsQuery = {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      }
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.wechatAppletquery.page_size = e
      this.getweichatlist()
    },
    fetchCurrentPage(e) {
      this.wechatAppletquery.page = e
      this.getweichatlist()
    },
    // 发送辑数据请求
    getConfirmData(id, form) {
      modify(id, form).then(res => {
        this.getListData()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    },
    async importReport() {
      const file = new FormData()
      file.append('file', this.$refs.inputFile.files[0])
      await importReport(file)
      this.$message({
        message: '导入报表成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="less">
.accountManagement {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
